import { moneyString } from '@hesabat/contracts';
import { Money } from '@hesabat/finance-core';

/**
 * المال فى الواجهة نص من الإدخال إلى الإرسال، ويُحسب بـ `Money` وحده —
 * `Number('0.1') + Number('0.2')` لا يساوى 0.3، فإجمالى قيد يظهر «غير متزن»
 * وهو متزن، أو العكس.
 */

const ARABIC_INDIC = /[٠-٩]/g;
const EASTERN_ARABIC = /[۰-۹]/g;

/**
 * يقبل ما يكتبه محاسب مصرى فعلاً: أرقام هندية (١٢٣)، فاصلة عشرية عربية (٫)،
 * وفواصل آلاف (، أو ٬). يُعيد نصًا عشريًا صالحًا للعقد، أو `null` إن تعذّر.
 * الحقل الفارغ صفر — السطر يحمل مدينًا أو دائنًا لا الاثنين.
 */
export function parseAmount(input: string): string | null {
  const normalized = input
    .trim()
    .replace(ARABIC_INDIC, (digit) => String(digit.charCodeAt(0) - 0x0660))
    .replace(EASTERN_ARABIC, (digit) => String(digit.charCodeAt(0) - 0x06f0))
    .replace(/٫/g, '.')
    .replace(/[,٬\s]/g, '');

  if (normalized === '') return '0';
  if (!moneyString.safeParse(normalized).success) return null;
  if (normalized.startsWith('-')) return null;
  return Money.of(normalized).toString();
}

/** مجموع نصوص مالية — للإجماليات فى النموذج والجداول. */
export function sumAmounts(amounts: readonly string[]): Money {
  return Money.sum(amounts).normalize();
}

/** عرض بخانتين وفواصل آلاف، بلا مرور على `number`. */
export function formatMoney(amount: string | Money): string {
  const fixed = Money.of(amount).toFixed(2);
  const negative = fixed.startsWith('-');
  const [whole = '0', fraction = '00'] = (negative ? fixed.slice(1) : fixed).split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return (negative ? '-' : '') + grouped + '.' + fraction;
}

export function isZero(amount: string): boolean {
  return Money.of(amount).isZero();
}

/** كمية للعرض: بلا أصفار عشرية زائدة (15.0000 ← 15، و2.5000 ← 2.5) وبفواصل آلاف. */
export function formatQuantity(quantity: string | Money): string {
  const fixed = Money.of(quantity).toFixed(4);
  const negative = fixed.startsWith('-');
  const [whole = '0', fraction = ''] = (negative ? fixed.slice(1) : fixed).split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const trimmed = fraction.replace(/0+$/, '');
  return (negative ? '-' : '') + grouped + (trimmed ? '.' + trimmed : '');
}
